module.exports = __webpack_public_path__ + "static/media/carlolopez.ec639cc8.jpeg";